import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c4a4674"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 承認作業中です。ユーザ確認の電話をお待ちください。")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" しばらく待っても電話が来ない場合、お問い合わせください。 ")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "card"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, " お知らせ ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  title: "お知らせ",
  src: "https://www.faq.nicotto-admin.jp/oshirase/index.html",
  height: "80"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "card mt-5"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, " 手続き案内サービス ", -1))
const _hoisted_13 = { class: "card-body my-2 d-flex flex-wrap justify-content-around dashboard" }
const _hoisted_14 = { class: "me-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "サイト管理", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtxt" }, "タイトルやロゴの設定", -1))
const _hoisted_17 = { class: "me-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "担当課管理", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtxt" }, "窓口の担当や所在地", -1))
const _hoisted_20 = { class: "me-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "手続き管理", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtxt" }, "必要な手続き種類", -1))
const _hoisted_23 = { class: "me-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "質問管理", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtxt" }, "質問や手続きの詳細", -1))
const _hoisted_26 = {
  key: 3,
  class: "card mt-5"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  title: "FAQ",
  src: "https://www.faq.nicotto-admin.jp/faq/menu.html",
  height: "440"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]

import { ref } from 'vue'
import { useStore } from '@/store'
import { MunicipalityServices } from '@/plugins/nicotto'
import IconGlove from '../components/ui/IconGlove.vue'
import IconUsers from '../components/ui/IconUsers.vue'
import IconFilePen from '../components/ui/IconFilePen.vue'
import IconCircleQuestion from '../components/ui/IconCircleQuestion.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const store = useStore()
const municipality = store.getters.isAdmin
  ? store.state.municipality
  : store.state.user?.municipality

// 利用可能サービス
const services = ref<MunicipalityServices>(municipality?.getServices() || {})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(municipality)?.status() === 'notAccepted')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : _createCommentVNode("", true),
    (_unref(municipality)?.status() === 'enabled')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
      : _createCommentVNode("", true),
    (services.value.concierge)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: "/concierge/settings",
              class: "btn btn-outline-secondary btn-lg mr-1",
              role: "button"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(IconGlove)
                ]),
                _hoisted_15,
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/concierge/departments",
              class: "btn btn-outline-secondary btn-lg mr-1",
              role: "button"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(IconUsers)
                ]),
                _hoisted_18,
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/concierge/processes",
              class: "btn btn-outline-secondary btn-lg mr-1",
              role: "button"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_20, [
                  _createVNode(IconFilePen)
                ]),
                _hoisted_21,
                _hoisted_22
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/concierge/categories",
              class: "btn btn-outline-secondary btn-lg mr-1",
              role: "button"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_23, [
                  _createVNode(IconCircleQuestion)
                ]),
                _hoisted_24,
                _hoisted_25
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(municipality)?.status() === 'enabled')
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
      : _createCommentVNode("", true)
  ]))
}
}

})